<!-- <div class="logo-des">
    <img src="./assets/media/icons/png/Cryixcropped.png" alt="My Image">
</div> -->

<form id="form_body" [formGroup]="Facility" novalidate="" class="custom-forms form-horizontal">
    <!-- <div class="modal-body container"> -->
        <!-- <h4>{{'CYRIX.FACINFO' | translate}}</h4> -->
        <!-- <div class="row formparentRow">
            <div class="col-sm-6 col-md-6">
                <div class="row">
                    <div class="col-sm-5 col-md-5">
                        <label class="control-label centeredlabel">{{'RAISETCKT.STATE' |translate}}</label>
                    </div>
                    <div class="col-sm-7 col-md-7">
                        <select formControlName="state_id" class="form-control" (change)="onChangeState($event.target.value)">
                            <option value="null" hidden>--{{'NEW_SUBSCRIPTION.SELECT_SEL' | translate}}
                                {{'RAISETCKT.STATE'|translate}}-- </option>
                            <option *ngFor="let items of states" [value]=items.state_id>
                                {{items.state_name}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-6">
                <div class="row">
                    <div class="col-sm-5 col-md-5">
                        <label class="control-label centeredlabel">{{'NEW_SUBSCRIPTION.DTRCT' | translate}}</label>
                    </div>
                    <div class="col-sm-7 col-md-7">
                        <select formControlName="district_id" class="form-control">
                            <option value="null" hidden>--{{'NEW_SUBSCRIPTION.SELECT_SEL' | translate}}
                                {{'NEW_SUBSCRIPTION.DTRCT' | translate}}-- </option>
                            <option *ngFor="let items of districts" [value]=items.city_id>
                                {{items.city_name}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="row formparentRow">
            <div class="col-sm-4 col-md-4">
                <div class="row">
                    <div class="col-sm-5 col-md-5">
                        <label class="control-label centeredlabel">Enter Barcode</label>
                    </div>
                    <div class="col-sm-7 col-md-7">
                        <input type="text" formControlName="barcode" class="form-control" name="barcode" id="barcode" placeholder="Enter Barcode">
                    </div>
                </div>
            </div>
            <div class="col-sm-2 col-md-2">
                <button class="btn btnFill" (click)="searchBarCode()">Go</button>
            </div>
        </div>
        <div class="row">
            <div id="tables" class="table-responsive GeneralTable text-nowrap">
                <table  datatable="ng" *ngIf="showTable" class="table-bordered datatable w-auto mw-100"  [dtOptions]="dtOptions">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>{{'CYRIX.BARCODE' | translate}}</th>
                            <th>{{'CYRIX.PRODGRP' | translate}}</th>
                            <th>{{'CYRIX.DEVGROUP' | translate}}</th>
                            <th>{{'CYRIX.DEVMAKE' | translate}}</th>
                            <th>{{'CYRIX.DEVMODEL' | translate}}</th>
                            <th>{{'CYRIX.DEVCLASS' | translate}}</th>
                            <!-- <th>{{'CYRIX.CONTRACTID' | translate}}</th> -->
                            <th>{{'CYRIX.EXDATE' | translate}}</th>
                            <th>{{'NEW_SUBSCRIPTION.ACTION' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="product_details?.length > 0">
                        <tr *ngFor="let product of product_details; let i = index;">
                            <td>{{i+1}}</td>
                            <td >{{product.serial_no}}</td>
                            <td>{{product.product.product_name}}</td>
                            <td>{{product.sub_product.product_sub_name}}</td>
                            <td>{{product.model.model_name}}</td>
                            <td>{{product.part_number}}</td>
                            <td>{{product.facility_device_class}}</td>
                            <!-- <td class="datacolor">{{product.assert_id}}</td> -->
                            <td *ngIf="product.expiry_day != null ">{{product.expiry_day}}</td>
                            <td  style="text-align: center;" *ngIf="product.expiry_day == null ">-</td>
                            <td>
                                <button *ngIf="product.ticket_base == 'No' " type="button" class=" btn-pill btn-sm custom-btn ml-2 disabledsubmit successbtn padbut" (click)="raisecomplaint()">Raise Ticket</button>
                                <button *ngIf="product.ticket_base == 'Yes' " type="button" class="btn-outline colorwhite padbut">Open Ticket</button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="product_details?.length == 0">
                        No Records Found
                    </tbody>
                </table>
            </div>
        </div>
    <!-- </div> -->
</form>
<!-- begin:: Footer -->
<!-- <div class="kt-footer kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop" id="kt_footer">
    <div class="row kt-container" [ngClass]="{'kt-container--fluid': fluid}">
      <div class="col-lg-5 kt-footer__copyright">
        <img style="height: 20px;" src="./assets/media/icons/png/FieldProLogo3.png" alt="My Image">
        <a style="margin-top: 6px;" href="http://kaspontech.com" target="_blank" class="kt-link">Powered by Kaspon Techworks Pvt Ltd</a>
      </div>
      <div class="col-lg-4 kt-footer__copyright"></div>
      <div style="margin-top: 6px;" class="col-lg-3 kt-footer__copyright">&nbsp;&copy;&nbsp; {{today | date:'yyyy'}}.&nbsp; 
        All rights reserved by 
        <a href="https://www.cyrixhealthcare.com" target="_blank" class="kt-link">&nbsp; Cyrix Healthcare Pvt Ltd.</a>
    </div>
  </div>
  </div> -->
  <!-- end:: Footer -->